import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import {
  fetchDeleteEshopInfoItem,
  fetchGetEshopInfoList,
  fetchGetEshopPriceType,
  fetchGetEshopTypes,
  receiveGetEshopInfoList,
} from '../../../../../actions/admin';
import styled from '@emotion/styled';
import { TableContainer } from '../styled';
import SpinnerBlock from '../../../../common/SpinnerBlock';
import { TAB_MODS } from '../../../../../config/mods';
import Button from '../../../../common/Button';
import { showModal } from '../../../../../actions/modal';

const Wrapper = styled('div')`
  .edit-item {
    .action-icon {
      visibility: hidden;
      margin-left: 5px;
    }

    &:hover {
      .action-icon {
        visibility: initial;
        cursor: pointer;
      }
    }
  }

  .action-icon {
    font-size: 18px;
    margin-left: 50px;
  }

  .correction-data {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .th {
    border: none;
  }

  . {
    text-align: center;
    width: 70px;
  }

  .green-check {
    font-size: 24px;
    color: green;
  }

  .add-button {
    margin-left: auto;
    margin-top: -28px;
  }

  .action-icons-wrap i {
    font-size: 19.2px;
  }

  .action-column-title {
    width: 0;
    padding: 0;
  }

  .action-icons-td {
    padding: 0;
  }

  .action-icons-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .fe-trash {
    margin-top: 8px;
  }

  .sort-arrows {
    height: 17px;
    width: 17px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7X QMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC');
    cursor: pointer;
    margin-left: -17px;
  }

  .th-type-wrapper {
    display: flex;
  }
`;

const MarketplacesList = (props) => {
  const { handleSwitchMarketplaceMode } = props;

  const dispatch = useDispatch();

  const [showSpinner, setShowSpinner] = useState(true);

  const marketplaces = useSelector((state) => state.admin?.eshopInfoList);
  const marketplaceTypes = useSelector((state) => state.admin.eshopTypes);
  const priceTypes = useSelector((state) => state.admin?.eshopPriceType);

  useEffect(() => {
    handleFetchMarketplaces();
    if (!priceTypes) {
      handleFetchProductPriceType();
    }
  }, []);

  useEffect(() => {
    if (!marketplaceTypes) {
      getMarketplaceTypes();
    }
  }, [marketplaceTypes]);

  const getMarketplaceTypes = async () => {
    try {
      dispatch(fetchGetEshopTypes());
    } catch (error) {}
  };

  const handleFetchMarketplaces = async () => {
    try {
      await dispatch(fetchGetEshopInfoList());
    } catch (error) {}
    setShowSpinner(false);
  };

  const handleFetchProductPriceType = async () => {
    try {
      await dispatch(fetchGetEshopPriceType());
    } catch (error) {}
  };

  const onMarketplaceDeleting = async (onClose, id) => {
    onClose();
    try {
      await dispatch(fetchDeleteEshopInfoItem(id));
      await dispatch(handleFetchMarketplaces());
    } catch (error) {}
  };

  const handleDeleteMarketplaceById = async (id, title, name) => {
    dispatch(
      showModal('ConfirmDeleteMarketplace', {
        id,
        title,
        name,
        onMarketplaceDeleting,
      }),
    );
  };

  const displayCorrectPriceTypeName = useMemo(() => (currentPriceTypeCode) => {
    if (!priceTypes) return currentPriceTypeCode;
    const currentPriceType = priceTypes?.find((p) => p.code === currentPriceTypeCode);
    return currentPriceType ? currentPriceType.name : currentPriceTypeCode;
  });

  return (
    <Wrapper>
      <div className="row">
        <Button
          className="btn add-button mb-2 mr-1"
          onClick={() => handleSwitchMarketplaceMode(TAB_MODS.ADD)}
          text="Создать магазин"
        />
      </div>
      <TableContainer>
        <div className="fixed-table-container">
          <div className="fixed-table-body mt-2">
            <table className="table table-centered">
              <thead className="thead-light">
                <tr>
                  <th className="action-column-title" />
                  <th>МП</th>
                  <th className="text-center">Активен</th>
                  <th>Название магазина</th>
                  <th>Склад</th>
                  <th>Цена товара после скидки</th>
                </tr>
              </thead>
              <tbody>
                {marketplaces?.length > 0 ? (
                  marketplaces.map((m, index) => (
                    <tr key={index} className="edit-item">
                      <td className="action-icons-td">
                        <div className="action-icons-wrap">
                          <i
                            className="fe-edit edit-icon action-icon eshop-edit-icon"
                            onClick={() => handleSwitchMarketplaceMode(TAB_MODS.EDIT, m.code)}
                          />
                          <i
                            className="fe-trash edit-icon action-icon"
                            onClick={() => handleDeleteMarketplaceById(m.code, m.title, m.name)}
                          />
                        </div>
                      </td>
                      <td>{m?.title}</td>
                      <td className="text-center">
                        {m.isActive && <i className="fe-check green-check" />}
                      </td>
                      <td>{m?.name}</td>
                      <td>{m.warehouse?.name}</td>
                      <td>{displayCorrectPriceTypeName(m?.priceType)}</td>
                    </tr>
                  ))
                ) : (
                  <SpinnerBlock style={{ marginTop: '75px' }} show={showSpinner} />
                )}
              </tbody>
            </table>
          </div>
        </div>
      </TableContainer>
    </Wrapper>
  );
};

export default MarketplacesList;
